import BaseComponent from '../base-component/base-component'
import SidebarFiltersMobile from './sidebar-filters-mobile'
import Shop from '../shop/shop'

class FiltersSubmitBtn extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('click', this.handleButtonClick)
  }

  disconnectedCallback(): void {
    this.removeEventListener('click', this.handleButtonClick)
  }

  handleButtonClick = (): void => {
    const shop = this.closest<Shop>('shop-component')
    const sidebar = this.closest<SidebarFiltersMobile>('#SidebarFiltersMobile')

    if (shop) {
      const searchParams = [shop.filterQuery, shop.sortQuery].join('&')

      shop.updateShopBySearchParams(searchParams)
    }

    if (sidebar) {
      sidebar.hide()
    }
  }
}

export default FiltersSubmitBtn
